<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-6">Chlamydia</p>
<p class="BT-Opener"><span class="Drop _idGenCharOverride-1">I</span><span class="Drop CharOverride-9"> </span>didn’t know it would be such a big deal; it’s not like it’s incurable. Nobody’s going to die. We’ll take antibiotics and then, ten days later, it’ll be gone. But now he thinks I’m a total slut. And I must be, since I’ve infected people. But I think he’s being unfair. It shouldn’t matter this much. He acts like I’ve rejected him because I’ve been with other men. We weren’t together when I went to Central America; we’d gone on one date and I hadn’t even slept with him. I was traveling alone, so I slept around because I had nothing better to do and I needed to fill in the gaps. I didn’t know that something would grow between us; in fact, I thought it’d never happen, but I became more and more taken with him as I traveled. He sent me near-constant emails and he was always ready to talk when I went to internet cafés. We just started to connect. When I came home, we clicked; I fell head over heels. He’s beautiful and smart—I don’t know how many books he owns, hundreds at least, and he has this crazy DVD collection. </p>
<p class="BT">But the chlamydia kept eating at him. He wouldn’t stop interrogating me about the other boys. I held back at first. I only told him about one guy, a Norwegian in Cuba, and then I added the next one to the list—followed by the third, the fourth, the fifth, fuck, I can’t be expected to remember everything. I tried to explain that my memory isn’t really that great, but he thinks I’m lying. We were gliding on a smooth current, and now he wants nothing to do with me. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802157409-5.vue?b20b6846